import React, { useEffect, useState } from "react";

//UI Material
import { CircularProgress, Grid } from "@mui/material";

//Helpers
import { typographyForMainTitles } from "../Helpers/typography";
import { fetchWithTokenJSONPost } from "../Helpers/network";

//Local components
import RegisteredUsersList from "../Components/users-page/RegisteredUsersList";
import ErrorBox from "../Components/ErrorBox";

export default function Users() {
  // ==========>Component States<==========

  //State for users list
  const [usersList, setUsersList] = useState([]);
  //State for setting loader for orders data
  const [dataLoader, setDataLoader] = useState(false);
  //State for setting error when could not get orders data
  const [dataError, setDataError] = useState(false);

  // ==========>Component UseEffects<==========
  //The useEffect checks for token validation
  useEffect(() => {
    getUsersList();
    // Configurar el intervalo para ejecutar cada 5 minutos
    const interval = setInterval(() => {
      getUsersList();
    }, 300000);
    // Limpiar el intervalo cuando el componente se desmonte o cuando las dependencias cambien
    return () => {
      clearInterval(interval);
    };
  }, []);

  // ==========>Component Functions<==========
  //Function to get users list
  const getUsersList = async () => {
    setDataLoader(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(`/users/get`, {
        howMany: 500,
      });
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setUsersList(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setDataError(true);
    }
    setDataLoader(false);
  };

  return ( dataError ? <ErrorBox/> : 
    <Grid container justifyContent="center" textAlign="center" spacing={2}>
      <Grid item xs={12} align="center">
        {typographyForMainTitles("Administrador de Usuarios")}
      </Grid>
      <Grid item xs={12}>
        {dataLoader ? <CircularProgress/> : <RegisteredUsersList users={usersList} getUsers={getUsersList}/>}
      </Grid>
    </Grid>
  );
}
